<div class="footer-container">
    <section class="copyright-statement">
        © {{ currentYear.toString() }} nCino, All Rights Reserved
    </section>
    <section *ngIf="currentUserStateService.isLoggedIn()" class="copyright-statement">
        <a href="https://www.ncino.com/mortgage-aup" target="_blank">Acceptable Use</a>
        <span class="empty-space"></span>
        <a href="https://www.ncino.com/privacy-policy" target="_blank">Privacy Policy</a>
    </section>
</div>
